<template>
  <div class="page-container">
    <div class="header">
      <div class="title">分账批次管理</div>
    </div>
    <div class="search-form">
      <el-form
        class="search-form-content"
        inline
        :model="form"
        label-width="120px"
        label-position="left">
        <el-row>
          <el-col :span="8">
            <el-form-item label="分账申请时间" size="small">
              <el-date-picker
                v-model="applyTimeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="批次号" size="small">
              <el-input v-model="form.splitBatchNo" placeholder="请输入分账批次号" clearable />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="分账状态" size="small">
              <el-select v-model="form.batchStatus">
                <el-option v-for="([key, label], index) in Object.entries(batchStatusMap)" :value="key" :label="label" :key="index" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分账完成时间" size="small">
              <el-date-picker
                v-model="completeTimeRange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                align="right"
                size="small" />
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item size="small">
              <el-button type="primary" @click="handleFormSearch" class="bs-btn" :loading="table.loading">查询</el-button>
              <el-button @click="handleFormReset" class="bs-btn2">重置</el-button>
              <el-button @click="exportTable" class="bs-btn" :loading="exportLoading">导出</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="table-container">
      <el-table :data="table.data" style="width: 100%;" border v-loading="table.loading">
        <el-table-column prop="splitTime" label="分账申请时间" align="center" min-width="250px" />
        <el-table-column prop="updateTime" label="完成时间" align="center" min-width="150px" />
        <el-table-column prop="splitBatchNo" label="批次号" align="center" min-width="150px" />
        <el-table-column prop="totalAmount" label="总分账金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.totalAmount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="totalCount" label="总分账笔数" align="center" min-width="150px" />
        <el-table-column prop="successAmount" label="成功金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.successAmount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="successCount" label="成功笔数" align="center" min-width="150px" />
        <el-table-column prop="failedAmount" label="失败金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.failedAmount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="failedCount" label="失败笔数" align="center" min-width="150px" />
        <el-table-column prop="batchStatus" label="批次状态" align="center" min-width="150px">
          <template slot-scope="{row}">{{ batchStatusMap[row.batchStatus] || '' }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="80px">
          <template slot-scope="{row}">
            <el-button type="text" @click="openDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="table.totalCount > 0"
          :page-size="table.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="table.totalCount"
          :current-page="table.pageNo"
          @current-change="onChangeCurrentPage" />
      </div>
    </div>
    <el-dialog title="详情" :visible.sync="showDetailDialog" width="1000px" center>
      <div class="detail-form-container">
        <el-form label-width="200px" label-position="left" class="detail-form">
          <el-form-item label="当前批次号">{{ detailForm.splitBatchNo || '-' }}</el-form-item>
          <el-form-item label="分账申请时间">{{ detailForm.splitTime || '-' }}</el-form-item>
          <el-form-item label="当前批次计划分帐金额">{{ sToFixed(detailForm.totalAmount / 100) }}</el-form-item>
          <el-form-item label="当前批次计划分帐笔数">{{ detailForm.totalCount }}</el-form-item>
        </el-form>
      </div>
      <el-table :data="detailForm.detailList" style="width: 100%;margin-top: 40px;" border v-loading="table.loading">
        <el-table-column prop="receiveMerchantId" label="接收方商编" align="center" min-width="250px" />
        <el-table-column prop="receiveMerchantName" label="接收方商户名称" align="center" min-width="150px" />
        <el-table-column prop="planAmount" label="计划分账金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.planAmount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="actualAmount" label="到账金额" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.actualAmount / 100) }}</template>
        </el-table-column>
        <el-table-column prop="serviceFee" label="分账服务费" align="center" min-width="150px">
          <template slot-scope="{row}">{{ sToFixed(row.serviceFee / 100) }}</template>
        </el-table-column>
        <el-table-column prop="batchStatus" label="分账状态" align="center" min-width="150px">
          <template slot-scope="{row}">{{ batchStatusMap[row.batchStatus] || '' }}</template>
        </el-table-column>
        <el-table-column label="操作" align="center" min-width="80px">
          <template slot-scope="{row}">
            <el-button type="text" @click="openDialogDetail(row)">详情</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination-content">
        <el-pagination
          v-if="detailForm.totalCount > 0"
          :page-size="detailForm.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="detailForm.totalCount"
          :current-page="detailForm.pageNo"
          @current-change="onChangeDialogCurrentPage" />
      </div>
    </el-dialog>
    <el-dialog :title="`分账详情-${detailDialogForm.receiveMerchantName}-${batchStatusMap[detailDialogForm.batchStatus]}`" :visible.sync="showDialogDetailDialog" width="500px" center>
      <div class="detail-form-container">
        <el-form label-width="150px" label-position="left" class="detail-form">
          <div class="detail-form-title">订单信息</div>
          <el-form-item label="分账流水号">{{ detailDialogForm.splitSerialNo }}</el-form-item>
          <el-form-item label="关联批次号">{{ detailDialogForm.splitBatchNo }}</el-form-item>
          <div class="detail-form-title">接收方信息</div>
          <el-form-item label="名称">{{ detailDialogForm.receiveMerchantName }}</el-form-item>
          <el-form-item label="账号类型">{{ merchantTypeMap[detailDialogForm.merchantType] || '' }}</el-form-item>
          <el-form-item label="账号">{{ detailDialogForm.bankAccountNo }}</el-form-item>
          <el-form-item label="分账金额">{{ sToFixed(detailDialogForm.actualAmount / 100) }}</el-form-item>
          <el-form-item label="状态">{{ batchStatusMap[detailDialogForm.batchStatus] || '' }}</el-form-item>
          <el-form-item v-if="detailDialogForm.batchStatus !== 0" :label="`${batchStatusMap[detailDialogForm.batchStatus]}时间`">{{ detailDialogForm.successTime }}</el-form-item>
          <el-form-item label="支付渠道流水号">{{ detailDialogForm.innerTransferNo }}</el-form-item>
          <el-form-item label="备注">{{ detailDialogForm.remark }}</el-form-item>
        </el-form>
      </div>
    </el-dialog>
  </div>
</template>
<script>
// copilot begin
import moment from "moment";
import {
  downloadSplitBatchInfo, listSplitBatchInfo, querySplitBatchDetail, querySplitSerialDetail,
} from "../../../api/cloud-manage";
import { debounce, sToFixed } from "@/utils/index";

const FORMAT = 'yyyy-MM-DD HH:mm:ss';

export default {
  name: "split-batch-manage",
  data() {
    const startTime = moment().startOf('day').subtract(30, 'days').format(FORMAT);
    const endTime = moment().endOf('day').format(FORMAT);
    return {
      batchStatusMap: {
        0: '处理中',
        1: '成功',
        2: '失败',
        3: '部分成功',
      },
      businessTypeMap: {
        1: '充值',
        2: '充值撤销',
        3: '消费',
        4: '消费撤销',
        5: '转账',
        6: '转账撤销',
        7: '提现',
        8: '提现撤销',
      },
      merchantTypeMap: {
        1: '个人',
        2: '个体',
        3: '企业',
      },
      applyTimeRange: [startTime, endTime],
      completeTimeRange: [],
      form: {
        splitBatchNo: '',
        batchStatus: '',
      },
      exportLoading: false,
      table: {
        loading: false,
        data: [],
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
      },
      showDetailDialog: false,
      detailDialogLoading: false,
      detailForm: {
        splitTime: '',
        splitBatchNo: '',
        totalAmount: '',
        pageNo: 1,
        totalCount: 0,
        pageSize: 10,
        detailList: [],
      },
      showDialogDetailDialog: false,
      detailDialogForm: {},
    };
  },
  computed: {
    exportTable() {
      return debounce(this.exportTableFunc, 500, true);
    },
  },
  mounted() {
    this.handleFormSearch();
  },
  methods: {
    sToFixed,
    handleFormSearch() {
      this.table.pageNo = 1;
      this.queryTableData();
    },
    handleFormReset() {
      this.form = {
        splitBatchNo: '',
        batchStatus: '',
      };
      this.applyTimeRange = [];
      this.completeTimeRange = [];
      this.handleFormSearch();
    },
    exportTableFunc() {
      const [splitTimeStart, splitTimeEnd] = this.applyTimeRange || [];
      const [updateTimeStart, updateTimeEnd] = this.completeTimeRange || [];
      const params = {
        ...this.form,
        splitTimeStart,
        splitTimeEnd,
        updateTimeStart,
        updateTimeEnd,
      };
      this.exportLoading = true;
      downloadSplitBatchInfo(params).then(({ data: { code } }) => {
        if (code === '0') {
          this.$message.success('导出成功，请到下载中心下载报表文件！');
        }
      }).finally(() => {
        this.exportLoading = false;
      });
    },
    async queryTableData() {
      const { pageNo, pageSize } = this.table;
      const [splitTimeStart, splitTimeEnd] = this.applyTimeRange || [];
      const [updateTimeStart, updateTimeEnd] = this.completeTimeRange || [];
      const params = {
        ...this.form,
        pageNo,
        pageSize,
        splitTimeStart,
        splitTimeEnd,
        updateTimeStart,
        updateTimeEnd,
      };
      this.table.loading = true;
      const { data: { data: { list = [], totalCount = 0 } } } = await listSplitBatchInfo(params).finally(() => {
        this.table.loading = false;
      });
      this.table.data = list;
      this.table.totalCount = totalCount;
    },
    /**
     * 改变当前页事件
     * @param  {number} pageNo 当前页码
     */
    onChangeCurrentPage(pageNo) {
      this.table.pageNo = pageNo;
      this.queryTableData();
    },
    openDetail({ splitBatchNo }) {
      this.showDetailDialog = true;
      this.detailForm.splitBatchNo = splitBatchNo;
      this.queryDialogTableData();
    },
    onChangeDialogCurrentPage(pageNo) {
      this.detailForm.pageNo = pageNo;
      this.queryDialogTableData();
    },
    queryDialogTableData() {
      const { splitBatchNo, pageNo, pageSize } = this.detailForm;
      this.detailDialogLoading = true;
      querySplitBatchDetail({ splitBatchNo, pageNo, pageSize }).then(({ data: { data } }) => {
        this.detailForm = {
          ...this.detailForm,
          ...data,
        };
      }).finally(() => {
        this.detailDialogLoading = false;
      });
    },
    openDialogDetail({ splitSerialNo }) {
      const { splitBatchNo } = this.detailForm;
      querySplitSerialDetail({ splitBatchNo, splitSerialNo }).then(({ data: { data } }) => {
        this.detailDialogForm = data;
        this.showDialogDetailDialog = true;
      });
    },
  },
};
// copilot end
</script>

<style scoped lang="scss">
.page-container {
  > .header {
    padding-left: 50px;
    background-color: #fff;

    .title {
      position: relative;
      height: 80px;
      font-size: 18px;
      line-height: 80px;
      color: #333;

      &::after {
        position: absolute;
        right: 0;
        bottom: 0;
        left: -50px;
        display: block;
        height: 0;
        content: "";
        border-bottom: 1px solid #f2f3f3;
      }
    }
  }

  .search-form {
    padding: 40px 50px 20px;
    border-bottom: 20px solid #eee;

    .search-form-content {
      /deep/ .el-select,
      /deep/ .el-input {
        width: 210px;
      }
    }
  }

  .table-container {
    padding: 40px 50px 0;
    background: #fff;

    .pagination-content {
      margin-top: 10px;
      text-align: center;
    }
  }

  .detail-form-container {
    padding: 0 20px;

    /deep/ .el-form-item__label {
      font-weight: normal;
      color: #666;
    }

    /deep/ .el-form-item__content {
      color: #333;
      text-align: right;
    }

    /deep/ .el-form-item {
      margin-bottom: 0;
    }

    .detail-form-title {
      padding: 20px 0;
      font-size: 18px;
      font-weight: bold;
    }
  }
}
</style>
